export class BeheadingReportedQty{
    boxes:number;
    quantity:number;
}